export default "__VITE_ASSET__DXxIoKkk__"